export default {
  getActiveProcessOptions: (state) =>
    state.processOptions.find((e) => e.active === true) || {},
  processOptions: (state) => state.processOptions,
  getHeatProjectEditing: (state) => state.editHeatProjectNetwork,
  getLogoUrl: (state) => state.logoUrl,
};
